import { createContext } from 'react';

const CommentListContext = createContext(null);

export const CommentListContextProvider = CommentListContext.Provider;
export default CommentListContext;
